<template>
  <div class="">
帮助中心
  </div>
</template>

<script>
export default {
  name: '',
  components: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  created() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
</style>